import GtmService from '../gtm-service/GtmService';
import { navigate } from 'gatsby';

class InternalNavigation {
    navigation(url) {
        navigate(url);
        GtmService.handleNavigation(url);
    }
}

export default new InternalNavigation();
